/**
 * The width below which the portal treats the screen as a phone — where the
 * dashboard narrows its week to one day and the hours editor opens as a list.
 * One constant so those screens cannot disagree about what a phone is.
 *
 * Its own module rather than an export of `useMediaQuery.js`, which tests
 * replace wholesale with a stub that has no constants on it.
 */
export const PHONE_QUERY = '(max-width: 720px)';

/**
 * A touch-first device (phone or tablet, any width): no hover, a finger for a
 * pointer. Editors that are built around dragging small targets treat it like a
 * phone even when it is wider than {@link PHONE_QUERY} (a tablet, a phone held
 * sideways).
 */
export const TOUCH_QUERY = '(hover: none) and (pointer: coarse)';
